import {ContentResponseData} from '../type/ContentResponseData.interface';
import {LoadAsset} from './LoadAsset.class';

export class ContentLoadAsset extends LoadAsset {
  public chapterId;
  public contentId;

  public result?: ContentResponseData;

  constructor({
    url,
    chapterId,
    contentId,
  }: {
    url: string;
    chapterId: number;
    contentId: number;
  }) {
    super({type: 'Content', url});

    this.chapterId = chapterId;
    this.contentId = contentId;
  }
}
